export const colors = [
    '#FFFFFF',
    '#FFFFFF',
    '#5E1AF4',
    '#D599FB',
    '#FF2E4C',
    '#CDD71D',
    '#49DEB2',
    '#B1AAEB',
    '#BC8F6F',
    '#FFCD8F',
    '#57D2DA',
    '#B6D767',
    '#9FC5E8',
    '#F6B26B',
    '#9A63B4',
    '#2A225F',
    '#4D5A48',
    '#3D3623',
    '#E2C671',
    '#201144',
    '#700909',
    '#B45F06',
];
